module.exports = __webpack_public_path__ + "static/img/fuwu.00fbf39.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/fuwu.jpg
// module id = YMoZ
// module chunks = 1